import { useLocation, Redirect, Route } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";
import { MonitorContextProvider } from "../monitor/Monitor.context";
import { ConfigContextProvider } from './ConfigProvider'

const PrivateRoute = ({ loginPath, ...routeProps }) => {
    const { component, ...restRouteProps } = routeProps
    const location = useLocation();
    const isAuthenticated = useIsAuthenticated();
    const RenderRoute = () => {
        return (
            <>
                <Route
                    component={() => (
                        <ConfigContextProvider>
                            {
                                ['/teams/organize/:game_id'].includes(routeProps.path)
                                    ?  (
                                        <MonitorContextProvider>
                                            {component()}
                                        </MonitorContextProvider>
                                    )
                                    : component()
                            }
                        </ConfigContextProvider>
                    )}
                    {...restRouteProps}
                />
            </>
        )
    }
    return isAuthenticated()
        ? <RenderRoute />
        : <Redirect to={{
            pathname: loginPath, 
            state: {
                referrer:`${location.pathname}/${location.search}`,
            }
        }} />
}

export default PrivateRoute